import type { SkiSlopeDesktopV1Attributes } from '@/features/ski-slope/ski-slope-desktop-v1/ski-slope-desktop-v1-type';

import React from 'react';

import { KeyFacts, KeyFactsHorizontal, Modal, RawImage } from '@/core/features';
import IntermapsIframe from '@/features/ski-slope/intermaps-iframe';

import styles from './ski-slope-desktop-v1.module.scss';

type SkiSlopeDesktopV1Props = SkiSlopeDesktopV1Attributes;

export default function SkiSlopeDesktopV1({ iframeUrl, imageUrl, skiSlopeFacts, title, type }: SkiSlopeDesktopV1Props) {
    const [isOverlayOpen, setOverlayOpen] = React.useState(false);
    return (
        <div className={'flex-column gap-15'}>
            <div className={'font-size-18 bold'}>{title}</div>
            <div className={styles.contentContainer}>
                <div
                    className={styles.previewContainer}
                    data-qa-id={'qa-ski-slope-desktop'}
                    onClick={() => setOverlayOpen(true)}
                >
                    <RawImage
                        alt={''}
                        fetchPriority={'low'}
                        preload={false}
                        // eslint-disable-next-line no-inline-styles/no-inline-styles
                        style={{ objectFit: 'cover', position: 'absolute' }}
                        url={imageUrl.replace('http://', 'https://')}
                        width={'100%'}
                    />
                </div>
                <div className={'border-left-0 padding-20 padding-left-20 border border-alto border-radius-right'}>
                    <div className={'font-size-16 bold'}>{skiSlopeFacts.title}</div>
                    <div className={'gap margin-bottom-10 margin-top-10'}>
                        {skiSlopeFacts.groups.map((group, index) => {
                            return (
                                <div key={`${group.title}-${index}`}>
                                    {group.title && <div className={'margin-bottom-8'}>{group.title}</div>}
                                    {group.horizontal ? (
                                        <KeyFactsHorizontal
                                            fontSize={'font-size-14'}
                                            iconSize={15}
                                            isDesktopView={true}
                                            keyfacts={group.facts}
                                        />
                                    ) : (
                                        <KeyFacts
                                            gap={10}
                                            iconGap={'gap-12'}
                                            iconSize={15}
                                            keyFacts={group.facts}
                                            shouldReserveIconSpace={false}
                                        />
                                    )}
                                </div>
                            );
                        })}
                    </div>
                    <div className={styles.updatedText}>{skiSlopeFacts.updatedText}</div>
                </div>
                {isOverlayOpen && (
                    <Modal
                        maxHeight={'90vh'}
                        onClose={() => setOverlayOpen(false)}
                        padding={'padding-20'}
                        qaId={'qa-ski-slope-desktop-modal'}
                    >
                        <div
                            className={'padding-top-10 padding-bottom-20 padding-left-10 text-center font-size-18 bold'}
                        >
                            {title}
                        </div>
                        <IntermapsIframe
                            height={600}
                            iframeUrl={iframeUrl}
                            type={type}
                        />
                    </Modal>
                )}
            </div>
        </div>
    );
}
